// /assets/js/overlays.toggle.mutex.labels.mobile-aware.js
module.exports = (function () {
    var IDS = {
        translateBtn: 'translate',
        contactBtn: 'contact-expand',
        translateOverlay: 'google_translate_element_container',
        contactOverlay: 'contact-footer-section'
    };

    var CONFIG = {
        labelSwapBreakpoint: 768 // px; below/eq => mobile (icon-only), don't swap labels
    };

    function alreadyWired(el) { return el && el.dataset && el.dataset.overlayWired === '1'; }
    function markWired(el) { if (el && el.dataset) el.dataset.overlayWired = '1'; }

    function show(el) {
        if (!el) return;
        el.removeAttribute('hidden');
        el.classList.remove('hidden', 'd-none');
        el.style.removeProperty('display');
        if (getComputedStyle(el).display === 'none') el.style.display = 'block';
    }
    function hide(el) { if (el) el.style.display = 'none'; }
    function isOpen(el) {
        if (!el) return false;
        var cs = getComputedStyle(el);
        return cs.display !== 'none' && cs.visibility !== 'hidden';
    }

    function isMobile() {
        return typeof window !== 'undefined' &&
            window.matchMedia &&
            window.matchMedia('(max-width: ' + CONFIG.labelSwapBreakpoint + 'px)').matches;
    }

    // Preserve icon; replace label text
    var ICON_SEL = '.fa, .fa-solid, .fa-regular, .fa-brands, [class*="fa-"], .icon, [data-icon]';
    function getIconHTML(btn) {
        var icon = btn ? btn.querySelector(ICON_SEL) : null;
        return icon ? icon.outerHTML : '';
    }
    function readLabel(btn) {
        if (!btn) return '';
        var clone = btn.cloneNode(true);
        var icon = clone.querySelector(ICON_SEL);
        if (icon) icon.remove();
        return (clone.textContent || '').trim();
    }
    function setButtonLabel(btn, text) {
        if (!btn) return;
        var iconHTML = getIconHTML(btn);
        btn.innerHTML = (iconHTML ? iconHTML + ' ' : '') + (text ? text : '');
    }

    function isScrollable(el) {
        if (!el || el === document || el === window) return false;
        var cs = getComputedStyle(el);
        if (!cs) return false;
        var y = cs.overflowY;
        if (y !== 'auto' && y !== 'scroll' && y !== 'overlay') return false;
        return el.scrollHeight > el.clientHeight + 1;
    }

    function getScrollContainer(seedEl) {
        // Prefer native scrolling element first
        var se = document.scrollingElement;
        if (se && se.scrollHeight > se.clientHeight + 1) return se;

        // Walk up from the overlay/button to find a custom scroll container
        var cur = seedEl;
        while (cur && cur !== document.body && cur !== document.documentElement) {
            if (isScrollable(cur)) return cur;
            cur = cur.parentElement;
        }

        // Fall back to documentElement/body if one of them actually scrolls
        if (document.documentElement && document.documentElement.scrollHeight > document.documentElement.clientHeight + 1) {
            return document.documentElement;
        }
        return document.body || document.documentElement;
    }

    function scrollContainerToBottom(container, smooth) {
        if (!container) return;

        // Use a huge target; browsers clamp to max scrollTop.
        var target = 1e9;

        // If container is the doc scroller, drive via window.scrollTo to avoid quirks.
        var isDocScroller =
            container === document.scrollingElement ||
            container === document.documentElement ||
            container === document.body;

        if (isDocScroller) {
            try {
                window.scrollTo({ top: target, left: 0, behavior: smooth ? 'smooth' : 'auto' });
                return;
            } catch (_) {
                window.scrollTo(0, target);
                return;
            }
        }

        try {
            container.scrollTo({ top: target, left: 0, behavior: smooth ? 'smooth' : 'auto' });
        } catch (_) {
            container.scrollTop = target;
        }
    }

    function scrollToBottomWithRetries(seedEl) {
        if (typeof window === 'undefined' || typeof document === 'undefined') return;

        var container = getScrollContainer(seedEl);

        // Why: Translate widget can change layout after open; retries ensure final bottom.
        var runSmooth = function () { scrollContainerToBottom(container, true); };
        var runInstant = function () { scrollContainerToBottom(container, false); };

        if (typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(function () {
                window.requestAnimationFrame(runSmooth);
            });
        } else {
            setTimeout(runSmooth, 0);
        }

        setTimeout(runInstant, 50);
        setTimeout(runInstant, 250);
        setTimeout(runInstant, 600);
    }

    function init() {
        if (typeof window === 'undefined' || typeof document === 'undefined') return;
        if (window.__overlaysInitDone) return;
        window.__overlaysInitDone = true;

        var tBtn = document.getElementById(IDS.translateBtn);
        var cBtn = document.getElementById(IDS.contactBtn);
        var tOv = document.getElementById(IDS.translateOverlay);
        var cOv = document.getElementById(IDS.contactOverlay);
        if (!tBtn || !tOv || !cBtn || !cOv) return;

        // Original Razor labels (desktop); open-state labels default to "Close"
        var translateClosedLabel = readLabel(tBtn);
        var translateOpenLabel = tBtn.getAttribute('data-label-open') || 'Close';
        var contactClosedLabel = readLabel(cBtn);
        var contactOpenLabel = cBtn.getAttribute('data-label-open') || 'Close';

        function setTranslate(open) {
            if (open) {
                show(tOv);
                tBtn.setAttribute('aria-expanded', 'true');
                if (!isMobile()) setButtonLabel(tBtn, translateOpenLabel);
            } else {
                hide(tOv);
                tBtn.setAttribute('aria-expanded', 'false');
                if (!isMobile()) setButtonLabel(tBtn, translateClosedLabel);
            }
        }

        function setContact(open) {
            if (open) {
                cOv.classList.add('contact-open');
                show(cOv);
                cBtn.setAttribute('aria-expanded', 'true');
                if (!isMobile()) setButtonLabel(cBtn, contactOpenLabel);
            } else {
                cOv.classList.remove('contact-open');
                hide(cOv);
                cBtn.setAttribute('aria-expanded', 'false');
                if (!isMobile()) setButtonLabel(cBtn, contactClosedLabel);
            }
        }

        // Translate toggle + close Contact if opening + scroll to bottom of window
        if (!alreadyWired(tBtn)) {
            markWired(tBtn);
            tBtn.setAttribute('aria-controls', IDS.translateOverlay);
            tBtn.addEventListener('click', function (e) {
                e.preventDefault();
                var willOpen = !isOpen(tOv);
                if (willOpen && isOpen(cOv)) setContact(false);
                setTranslate(willOpen);

                if (willOpen) {
                    scrollToBottomWithRetries(tOv);
                }
            });
        }

        // Contact toggle + close Translate if opening + scroll into view
        if (!alreadyWired(cBtn)) {
            markWired(cBtn);
            cBtn.setAttribute('aria-controls', IDS.contactOverlay);
            cBtn.addEventListener('click', function (e) {
                e.preventDefault();
                var willOpen = !isOpen(cOv);
                if (willOpen && isOpen(tOv)) setTranslate(false);
                setContact(willOpen);

                if (willOpen && cOv && typeof cOv.scrollIntoView === 'function') {
                    try { cOv.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
                    catch (_) { cOv.scrollIntoView(true); }
                }
            });
        }

        // Close buttons inside translate overlay
        tOv.querySelectorAll('.translation-close-btn').forEach(function (btn) {
            if (alreadyWired(btn)) return;
            markWired(btn);
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                setTranslate(false);
            });
        });

        // Close buttons inside contact overlay
        cOv.querySelectorAll('.contact-close-btn').forEach(function (btn) {
            if (alreadyWired(btn)) return;
            markWired(btn);
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                setContact(false);
            });
        });

        // Global for inline onclick="translationToggle()"
        if (typeof window.translationToggle !== 'function') {
            window.translationToggle = function () {
                var willOpen = !isOpen(tOv);
                if (willOpen && isOpen(cOv)) setContact(false);
                setTranslate(willOpen);

                if (willOpen) {
                    scrollToBottomWithRetries(tOv);
                }
            };
        }

        // Optional: update labels if viewport crosses breakpoint while open
        if (window.matchMedia) {
            var mq = window.matchMedia('(max-width: ' + CONFIG.labelSwapBreakpoint + 'px)');
            if (!alreadyWired(mq)) {
                markWired(mq);
                mq.addEventListener('change', function () {
                    if (isMobile()) {
                        setButtonLabel(tBtn, translateClosedLabel);
                        setButtonLabel(cBtn, contactClosedLabel);
                    } else {
                        if (isOpen(tOv)) setButtonLabel(tBtn, translateOpenLabel);
                        else setButtonLabel(tBtn, translateClosedLabel);
                        if (isOpen(cOv)) setButtonLabel(cBtn, contactOpenLabel);
                        else setButtonLabel(cBtn, contactClosedLabel);
                    }
                });
            }
        }
    }

    if (typeof document !== 'undefined') {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init, { once: true });
        } else {
            init();
        }
    }

    return { init: init };
})();